<template>
  <div class="root-box">
    <el-tabs v-model="tab">
      <el-tab-pane label="核心" name="core">
        <core-analysis />
      </el-tab-pane>
      <el-tab-pane label="留存" name="retain" lazy>
        <retain />
      </el-tab-pane>
      <el-tab-pane label="复购" name="repurchase" lazy>
        <repurchase />
      </el-tab-pane>
      <el-tab-pane label="概况" name="ref1" lazy>
        <overview />
      </el-tab-pane>

      <el-tab-pane label="增长" name="ref2" lazy>
        <Incr />
      </el-tab-pane>

      <el-tab-pane label="行为" name="ref3" lazy>
        <behavior />
      </el-tab-pane>

      <el-tab-pane label="服务质量" name="service" lazy>
        <service-quality />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Overview from "./overview.vue";
import Incr from "./Incr";
import Behavior from "./Action";
import Retain from "./Retain";
import Repurchase from "./Repurchase";
import CoreAnalysis from "./Core";
import ServiceQuality from "./ServiceQuality";

export default {
  components: {
    Overview,
    Incr,
    Behavior,
    Retain,
    Repurchase,
    CoreAnalysis,
    ServiceQuality
  },
  props: {},
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  data() {
    return {
      tab: "core"
    };
  },
  methods: {}
};
</script>
<style lang="less" scoped></style>
